import * as React from "react";

import "./security-route.scss";

import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {Load2}                          from "@Common/react/load2";
import {Responsive}                     from "@Common/ui-components/responsive";
import {UserNameEdit}                   from "@Xpresso/routes/account/common/user-name-edit/user-name-edit";
import {AGENT_LEVEL, COMPANY_LEVEL}     from "@Xpresso/routes/common/logic/user-level";
import {EmulationModal}                 from "../../../common/emulation-modal/emulation-modal";
import {PasswordUpdateModal}            from "../../common/password-update-modal/password-update-modal";
import {SecurityQuestionModal}          from "../../common/security-question-modal/security-question-modal";
import {ProfileLayout}                  from "../common/profile-layout";

export const AccountSecurityRoute = () => cs(
    ({}, next) => ProfileLayout({activeTab: "security", next}),
    consumeContext("session"),
    consumeContext("userLevels"),
    consumeContext("apis"),
    ["emulationModal", (_, next) => EmulationModal({next})],
    ["agent", ({session}, next) => next(session?.data?.agent)],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ["managePasswordModal", ({apis}, next) => PasswordUpdateModal({
        next,
        title: "Password",
        onSave: apis.next.userProfile.updateUserProfile,
        urlParam: "password"
    })],
    ["securityQuestionModal", ({apis}, next) => SecurityQuestionModal({
        next,
        title: "Security Questions",
        onSave: apis.next.userProfile.updateUserProfile,
        urlParam: "questions"
    })],
    ["user", ({apis, session}, next) => Load2({
        _key: JSON.stringify({...session.value}),
        fetch: async () => apis.next.userProfile.getUserProfile(),
        next,
    })],
    ({agent, userLevels, emulationModal, managePasswordModal, securityQuestionModal, user}) => (
        !agent ? (
            <div className="security-route-f9y">
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            </div>
        ) : agent?.idAgent && agent?.idAgent != "Branch Order" ? (
            <div className="security-route-f9y">
                {userLevels.userLevel === AGENT_LEVEL &&
                    <>
                        {UserNameEdit({user})}
                        <div className="line"/>
                    </>
                }
                <div className="section">
                    <div className="header">
                        <div className="title">
                            Password
                        </div>
                        <a className="edit" xd-qa-type="link" xd-qa-name="Edit Manage Password" onClick={() => managePasswordModal.show()}>
                            Edit
                        </a>
                    </div>                
                </div>
                <div className="line"/>
                <div className="section">
                    <div className="header">
                        <div className="title">
                            Security Questions
                        </div>
                        <a className="edit" xd-qa-type="link" xd-qa-name="Edit Security Questions" onClick={() => securityQuestionModal.show()}>
                            Edit
                        </a>
                    </div>                    
                </div>
            </div>
        ) : (
            <div className="security-route-f9y">
                <div className="center">
                    {userLevels.userLevel !== AGENT_LEVEL ? (
                        <>
                            {"In order to see user details, you must "}
                            <a
                                className="emulation"
                                xd-qa-type="button"
                                xd-qa-name="Emulation"
                                onClick={() => emulationModal.show()}
                            >
                                {userLevels.userLevel === COMPANY_LEVEL ? (
                                    "Select Office & User"
                                ) : (
                                    "Select User"
                                )}
                            </a>
                        </>
                    ) : (
                        "Something went wrong"
                    )}
                </div>
            </div>
        )
    )
);
